import { render } from "./ModalPremise.vue?vue&type=template&id=8bd65c60&scoped=true"
import script from "./ModalPremise.vue?vue&type=script&lang=js"
export * from "./ModalPremise.vue?vue&type=script&lang=js"

import "./ModalPremise.vue?vue&type=style&index=0&id=8bd65c60&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd65c60"]])

export default __exports__